import { Icon, Text } from '@betterment/samba-react';
import { Button, Flex } from '@betterment/style-closet-react';

export interface Props {
  message: string;
  handleReload?: () => void;
}

const reload = () => window.location.reload();

const ErrorFallback: React.FC<React.PropsWithChildren<Props>> = ({ message, handleReload = reload }) => (
  <Flex height="100%" bg="white" alignItems="center" justifyContent="center" flexDirection="row">
    <Flex.Item mr="3" pt="8">
      <Text
        as="p"
        css={{
          textAlign: 'center',
          marginBottom: 'space.200',
          _last: { marginBottom: 'space.0' },
        }}
      >
        <Icon name="ExclamationCircle" size="small" color="icon" />
      </Text>
      <Text
        as="p"
        css={{
          lineHeight: 'lineHeight.100',
          textAlign: 'center',
          marginBottom: 'space.100',
        }}
      >
        {message}
      </Text>

      <Text
        as="p"
        css={{
          lineHeight: 'lineHeight.100',
          textAlign: 'center',
          marginBottom: 'space.200',
          _last: { marginBottom: 'space.0' },
        }}
      >
        <Button variant="tertiary" fontWeight="normal" m="0" pt="0" onClick={handleReload}>
          Reload
        </Button>
      </Text>
    </Flex.Item>
  </Flex>
);

export default ErrorFallback;
